import React, {useCallback, useState} from 'react';
import {toast} from 'react-toastify';
import BasicButton from '../../../../components/BasicButton';
import BasicInput from '../../../../components/BasicInput';
import FormRadio from '../../../../components/FormRadio';
import ENDPOINT from '../../../../constants/endpoints';
import useApi from '../../../../hooks/useApi';

const JotFormCreate = ({candidateId, onSuccess}) => {
  const api = useApi();
  const [createType, setCreateType] = useState('new');
  const [formSending, setFormSending] = useState(false);
  const [submissionId, setSubmissionId] = useState('');

  const create = useCallback(() => {
    setFormSending(true);
    let body = {candidateId};

    if (createType === 'existing') {
      body['submissionId'] = submissionId.trim();
    }

    api.postRequest(ENDPOINT.ENTITY.CANDIDATE_JOT_FORM, body, {
      handleSuccess: (response) => {
        onSuccess(response);
        toast.success('JotForm created successfully');
      },
      handleComplete: () => {
        setFormSending(false);
      },
      handleError: (error) => {
        toast.error(error.data.message);
      }
    });
  }, [candidateId, onSuccess, setFormSending, createType, submissionId]);

  return (
    <>
      <h3>Create JotForm</h3>
      <FormRadio
        value={createType}
        options={[
          {
            label: 'New Jotform',
            value: 'new',
          },
          {
            label: 'Existing Jotform',
            value: 'existing',
          },
        ]}
        onChange={(value) => {
          setSubmissionId('');
          setCreateType(value);
        }}
      />
      {createType === 'existing' && (
        <div style={{marginTop: '10px'}}>
          <BasicInput
            name={'id'}
            controlFunc={(e) => {
              setSubmissionId(e.target.value);
            }}
            placeholder={'Jotform Submission ID'}
            content={submissionId}
            isValid={true}
            required={true}
          />
        </div>
      )}
      <div style={{paddingTop: '20px'}}>
        <BasicButton btnText={'Create'} controlFunc={create} disabled={(formSending || createType === 'existing') && submissionId.trim() === ''} />
      </div>
    </>
  )
};

export default JotFormCreate;
